module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-3_0b9951895776f54b9406852e58a8cb34.png";